import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero (~600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-245">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden" data-id="element-246">
          <div className="bg-[#FDF8F0]/95 backdrop-blur-md border-t border-[#E8EDE6] px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-id="element-247">
            <a href="https://momentumdigitalpro.com/cart/44521034743910:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="flex items-center justify-center gap-2 w-full bg-[#2D3B2D] text-[#FDF8F0] py-3.5 rounded-full text-base font-medium active:scale-[0.98] transition-transform" data-id="element-248">
              Sí, quiero el Plan Antipánico
              <ArrowRightIcon className="w-4 h-4" data-id="element-249" />
            </a>
            <p className="text-center text-[10px] text-[#4A5D4A]/70 mt-1.5" data-id="element-250">
              Pago único · Acceso inmediato · Sin suscripción
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}